import { v4 as uuidV4, validate as uuidValidate, version as uuidVersion } from "uuid";
import get from "lodash.get";
import unset from "lodash.unset";
import { defaultTypeNameFromMapping } from "@readcube/rcp-meta";
import meta from "@readcube/rcp-meta/type_schema.json";
const doiUrlPrefixRegex = /^(https?:\/\/)?(dx\.)?doi\.org\//;
const validV4Uuid = (uuid) => uuidValidate(uuid) && uuidVersion(uuid) === 4;
const runSchemaValidations = (item, ctx, customSchema) => {
    const schema = customSchema || meta;
    const typeDef = schema.types[item.item_type];
    if (!typeDef) {
        ctx.addWarn(`No type definition found for item type "${item.item_type}".`);
        return;
    }
    const typeFieldNames = typeDef.fields;
    Object
        .entries(schema.field_defs)
        .filter(([name, def]) => typeFieldNames.includes(name) && def.input.pattern)
        .forEach(([name, def]) => {
        const pattern = new RegExp(def.input.pattern, def.input.pattern_insensitive ? 'i' : '');
        let value;
        if (def.readcube) {
            value = get(item, def.readcube);
        }
        else if (def.custom_metadata) {
            value = get(item.custom_metadata, def.custom_metadata);
        }
        if (value == null)
            return;
        if (def.readcube === 'ext_ids.doi') {
            const cleanDoi = value.replace(doiUrlPrefixRegex, '');
            item.ext_ids.doi = cleanDoi;
            value = cleanDoi;
        }
        if (!pattern.test(value)) {
            ctx.addWarn(`Field "${name}" with value "${value}" does not match pattern "${def.input.pattern}".`);
            if (def.readcube) {
                unset(item, def.readcube);
            }
            else if (def.custom_metadata) {
                unset(item.custom_metadata, def.custom_metadata);
            }
        }
    });
};
export const validateCore = ({ item, ctx, customSchema }) => {
    const itemIdIsSet = item.id != null;
    if (itemIdIsSet && !validV4Uuid(item.id)) {
        const oldItemId = item.id;
        item.id = uuidV4();
        ctx.addWarn(`Bad item id. Found "${oldItemId}". A new item id has been set for you: "${item.id}".`);
    }
    if (!item.item_type) {
        item.item_type = defaultTypeNameFromMapping(customSchema || meta);
        ctx.addWarn(`Item type must be set. A default value has been set for you: "${item.item_type}".`);
    }
    const authorsIsArray = item.article && item.article.authors
        ? Array.isArray(item.article.authors)
        : true;
    if (!authorsIsArray) {
        ctx.addWarn(`Item authors must be an array. Set to default value: []`);
        item.article.authors = [];
    }
    const tagsIsArray = item.user_data && item.user_data.tags
        ? Array.isArray(item.user_data.tags)
        : true;
    if (!tagsIsArray) {
        ctx.addWarn(`Tags must be an array. Set to default value: []`);
        item.user_data.tags = [];
    }
    if (!Object.keys(meta.types).includes(item.item_type)) {
        const oldType = item.item_type;
        item.item_type = defaultTypeNameFromMapping(customSchema || meta);
        ctx.addWarn(`Item type must be one of the Readcube types. Found "${oldType}". A default value has been set for you: "${item.item_type}".`);
    }
    const validColor = item.user_data && item.user_data.color
        ? /^#([a-f0-9]{3,4}|[a-f0-9]{4}(?:[a-f0-9]{2}){1,2})\b$/i.test(item.user_data.color)
        : true;
    if (!validColor) {
        ctx.addWarn(`Color must be a valid hex color. Found "${item.user_data.color}". Value removed.`);
        delete item.user_data.color;
    }
    const validateRating = (rating) => !isNaN(rating)
        && (0 < +rating)
        && (+rating < 6);
    const validRating = item.user_data && item.user_data.rating
        ? validateRating(item.user_data.rating)
        : true;
    if (!validRating) {
        ctx.addWarn(`Rating must be in 0-5 range. Found "${item.user_data.rating}". Value removed.`);
        delete item.user_data.rating;
    }
    const itemHasNoArticleSet = (item === null || item === void 0 ? void 0 : item.article) == null
        || Object.keys(item.article).length == 0
        || !(Object.values(item.article).findIndex(v => v != null) != -1);
    const hasDoi = item.ext_ids && item.ext_ids.doi != false;
    if (!hasDoi && itemHasNoArticleSet) {
        ctx.addError(`Missing item metadata`);
        return;
    }
    runSchemaValidations(item, ctx, customSchema);
};
